
/*
|--------------------------------------------------------------------------
| Coach User Session Evaluation Shares API Slice
|--------------------------------------------------------------------------
|
| First Created - 28 Oct 2026
|
| Step 11D - Coach Controlled Evaluation Sharing
|
|--------------------------------------------------------------------------
*/

import { apiSlice } from '@/app/api/apiSlice'

const SHARES_URL = '/coachUserSessionEvalShares'

export const coachUserSessionEvalSharesApiSlice =
    apiSlice.injectEndpoints({

        endpoints: builder => ({

            /*
            |--------------------------------------------------------------------------
            | Get Coach Sharing Status And History
            |--------------------------------------------------------------------------
            */

            getCoachUserSessionEvalShares: builder.query({

                query: evalMatrixId => ({
                    url: `${SHARES_URL}/getCoachShares`,
                    params: {
                        evalMatrixId,
                    },
                }),

                providesTags: (result, error, id) => [
                    {
                        type: 'CoachUserSessionEvalShare',
                        id,
                    },
                ],

            }),


            /*
            |--------------------------------------------------------------------------
            | Publish New Or Revised Snapshot
            |--------------------------------------------------------------------------
            */

            publishCoachUserSessionEvalShare:
                builder.mutation({

                    query: payload => ({

                        url: `${SHARES_URL}/publish`,

                        method: 'POST',

                        body: payload,

                    }),

                    invalidatesTags: (result, error, arg) => [
                        {
                            type: 'CoachUserSessionEvalShare',
                            id: arg.evalMatrixId,
                        },
                        {
                            type: 'CoachUserSessionEvalShare',
                            id: 'PARTICIPANT',
                        },
                    ],   

                }),


            /*
            |--------------------------------------------------------------------------
            | Revoke Participant Access
            |--------------------------------------------------------------------------
            */

            revokeCoachUserSessionEvalShare:
                builder.mutation({

                    query: payload => ({

                        url: `${SHARES_URL}/revoke`,

                        method: 'PUT',

                        body: payload,

                    }),

                    invalidatesTags: (result, error, arg) => [
                        {
                            type: 'CoachUserSessionEvalShare',
                            id: arg.evalMatrixId,
                        },
                        {
                            type: 'CoachUserSessionEvalShare',
                            id: 'PARTICIPANT',
                        },
                    ],

                }),


            /*
            |--------------------------------------------------------------------------
            | Participant Approved Evaluations
            |--------------------------------------------------------------------------
            |
            | Added now for Step 11E.
            |
            */

            getMySharedCoachEvaluations: builder.query({

                query: params => ({

                    url:
                        `${SHARES_URL}/getMySharedEvaluations`,

                    params,

                }),

                providesTags: [
                    {
                        type: 'CoachUserSessionEvalShare',
                        id: 'PARTICIPANT',
                    },
                ],

            }),

        }),

    })


export const {

    useGetCoachUserSessionEvalSharesQuery,

    usePublishCoachUserSessionEvalShareMutation,

    useRevokeCoachUserSessionEvalShareMutation,

    useGetMySharedCoachEvaluationsQuery,

} = coachUserSessionEvalSharesApiSlice